import { createSelector } from '@reduxjs/toolkit';
import { BookingInfo, BookingInfoResI } from '../models/BookingInfo';

export const bookingInfoResSelector = (state) => state.bookingInfoRes;
export const bookingIdToInfoResSelector = createSelector(
  bookingInfoResSelector,
  (
    storeState,
  ): {
    [id: string]: {
      isLoading: boolean;
      bookingInfoRes: BookingInfoResI;
    };
  } => storeState.bookingIdToInfoRes,
);

export const bookingNosHasLoadedInfo = createSelector(
  bookingIdToInfoResSelector,
  (bookingIdToInfoRes): string[] =>
    bookingIdToInfoRes
      ? Object.keys(bookingIdToInfoRes).filter(
          (res) => !!bookingIdToInfoRes[res].bookingInfoRes,
        )
      : [],
);
export const bookingIdToFoundAndNotCanceledSelector = createSelector(
  bookingIdToInfoResSelector,
  (bookingIdToInfoRes) =>
    bookingIdToInfoRes &&
    Object.keys(bookingIdToInfoRes).reduce((acc, id) => {
      const res = bookingIdToInfoRes[id];
      const bookingInfoM =
        res &&
        res.bookingInfoRes &&
        new BookingInfo(res.bookingInfoRes);
      if (!bookingInfoM) return acc;
      else
        return {
          ...acc,
          [id]: {
            found: bookingInfoM.found,
            notCanceled: !bookingInfoM.isCanceled,
          },
        };
    }, {}),
);

export const bookingIdToFoundAndNotCanceledSelectorOld = createSelector(
  bookingIdToInfoResSelector,
  (bookingIdToInfoRes) =>
    bookingIdToInfoRes &&
    Object.keys(bookingIdToInfoRes).reduce((acc, id) => {
      const res = bookingIdToInfoRes[id];
      const bookingInfoM =
        res &&
        res.bookingInfoRes &&
        new BookingInfo(res.bookingInfoRes);
      return {
        ...acc,
        [id]: !bookingInfoM
          ? { found: false }
          : {
              found: bookingInfoM.found,
              notCanceled: !bookingInfoM.isCanceled,
            },
      };
    }, {}),
);
export const showingBookingInfoIndexSelector = createSelector(
  bookingInfoResSelector,
  (storeState) => storeState.showingIndex,
);
export const bookingInfoIsLoadingAtRowIndexMapSelector = createSelector(
  bookingInfoResSelector,
  (storeState) => storeState.isLoadingAtRowIndex,
);
